import {
    Box, Flex,
    Heading, HStack,
    Text, useBoolean,
    useDisclosure,
    VStack
} from "@chakra-ui/react";
import {PaginationRow, StyledButton} from "../../../components";
import React, {useState} from "react";
import {ReactComponent as Delete} from "../../../assets/icons/profile/delete_icon.svg";
import {ReactComponent as Edit} from "../../../assets/icons/profile/edit.svg";
import {Screener} from "../../../helpers/data-jsons";

const Screeners = ({setActiveTab}) => {
    const {isOpen, onOpen, onClose} = useDisclosure()
    const [isOn, setIsOn] = useBoolean(true);

    const [currentPage, setCurrentPage] = useState(0);
    const [itemsPerPage, setItemsPerPage] = useState(2);
    const totalPages = Math.ceil(Screener.length / itemsPerPage);
    const currentItems = Screener.slice(currentPage * itemsPerPage, (currentPage + 1) * itemsPerPage);


    return (
        <VStack
            color={'neutral.100'}
            w={'100%'}>
            <Flex
                justifyContent={'space-between'}
                alignItems={'center'}
                p={{base: '16px 10px', md: '11px 0'}}
                w={'100%'}
            >
                <Heading color={'neutral.100'} fontSize={'heading.3xl'}>Screeners</Heading>
                <Box
                    onClick={() => setActiveTab('addScreeners')}
                >
                    <StyledButton>Add</StyledButton>
                </Box>
            </Flex>
            <Box
                w={'full'}
                p={{base: '16px',}}
                bg={'neutral.1100'}
                borderRadius={{base: '0', md: '16px'}}
                display={'flex'}
                flexDirection={'column'}
                gap={'16px'}
            >
                {currentItems.map((item) => (
                    <Box
                        key={item.id}
                        w={'full'}
                        display={'flex'}
                        flexWrap={'wrap'}
                        flexDirection={'column'}
                        gap={'24px'}
                        justifyContent={'space-between'}
                    >
                        <Flex
                            w={'full'}
                            flexDirection={'column'}
                            gap={'24px'}
                        >
                            <Box
                                w={'full'}
                                display={'flex'}
                                flexDirection={'row'}
                                alignItems={'center'}
                                justifyContent={'space-between'}
                            >
                                <Heading fontSize={'18px'}>Not1</Heading>
                                <Flex
                                    gap={'8px'}
                                    alignItems={'center'}
                                >
                                    <StyledButton
                                        maxHeight={'32px'}
                                        border={'solid 1px #5834A8'}
                                        padding={'8px 6px'}
                                        bg={'transparent'}
                                        maxWidth={'32px'}><Delete/>
                                    </StyledButton>
                                    <StyledButton
                                        maxHeight={'32px'}
                                        border={'solid 1px #5834A8'}
                                        padding={'8px 6px'}
                                        bg={'transparent'}
                                        maxWidth={'32px'}
                                    ><Edit/></StyledButton>
                                    <Box
                                        onClick={setIsOn.toggle}
                                        w={"44px"}
                                        h={"24px"}
                                        bg={isOn ? 'purple.600' : 'gray.600'}
                                        borderRadius={"full"}
                                        p={"4px"}
                                        cursor={"pointer"}
                                        transition={"background 0.3s ease"}
                                        display={'flex'}
                                        alignItems={'center'}
                                    >
                                        <Box
                                            w={"18px"}
                                            h={"18px"}
                                            bg="white"
                                            borderRadius={"50%"}
                                            transform={isOn ? 'translateX(18px)' : 'translateX(2px)'}
                                            transition={"transform 0.3s ease"}
                                        />
                                    </Box>
                                </Flex>
                            </Box>
                            <Flex
                                w={'full'}
                                gap={'1px'}
                                flexDirection={{base: 'column', md: 'row'}}
                            >
                                <VStack
                                    borderTopLeftRadius={{base: '0', md: '8px'}}
                                    borderBottomLeftRadius={{base: '0', md: '8px'}}
                                    p={'8px 16px 16px 16px'}
                                    bg={'neutral.1000'}
                                    gap={'24px'}>
                                    <Box>
                                        <Text fontSize={'16px'} p={'8px 12px'}>Exchanges for Selling</Text>
                                        <Box
                                            display={'flex'}
                                            flexWrap={'wrap'}
                                            gap={'8px'}
                                        >
                                            {item.selling.map((sell) => (
                                                <StyledButton
                                                    key={sell.id}
                                                    width={'max-content'}
                                                    maxHeight={'20px'}
                                                    bg={'#5834A8'}
                                                    fontWeight={'400'}
                                                    fontSize={'12px'}
                                                    fontSizeBase={'12px'}
                                                >{sell.title}</StyledButton>
                                            ))}
                                        </Box>
                                    </Box>
                                    <Box>
                                        <Text fontSize={'16px'} p={'8px 12px'}>Exchanges for Buying</Text>
                                        <Box
                                            display={'flex'}
                                            flexWrap={'wrap'}
                                            gap={'8px'}>
                                            {item.buying.map((buy) => (
                                                <StyledButton
                                                    key={buy.id}
                                                    width={'max-content'}
                                                    maxHeight={'20px'}
                                                    bg={'#5834A8'}
                                                    fontWeight={'400'}
                                                    fontSize={'12px'}
                                                    fontSizeBase={'12px'}
                                                >{buy.title}</StyledButton>
                                            ))}
                                        </Box>
                                    </Box>
                                </VStack>
                                <VStack
                                    borderTopRightRadius={'8px'}
                                    borderBottomRightRadius={'8px'}
                                    p={'8px 16px 16px 16px'}
                                    bg={'neutral.1000'}
                                >
                                    <Box>
                                        <Text fontSize={'16px'} p={'8px 12px'}>Notifications</Text>
                                        <Box>
                                            <Box
                                                display={'flex'}
                                                flexWrap={'wrap'}
                                                gap={'8px'}
                                            >
                                                {item.notification.map((notif) => (
                                                    <StyledButton
                                                        key={notif.id}
                                                        width={'max-content'}
                                                        maxHeight={'20px'}
                                                        bg={'#5834A8'}
                                                        fontWeight={'400'}
                                                        fontSize={'12px'}
                                                        fontSizeBase={'12px'}
                                                    >{notif.title}</StyledButton>
                                                ))}
                                            </Box>
                                        </Box>
                                    </Box>
                                </VStack>
                            </Flex>
                        </Flex>
                    </Box>
                ))}
                <PaginationRow
                    pageCount={totalPages}
                    onPageChange={setCurrentPage}
                    itemsPerPage={itemsPerPage}
                    onItemsPerPageChange={(newCount) => {
                        setItemsPerPage(newCount);
                        setCurrentPage(0);
                    }}
                />
            </Box>
        </VStack>

    )
}
export default Screeners